import { Box, Typography } from "@mui/material";
import check from "../../../../assets/images/check.svg";
import ButtonComp from "../../../../components/Button";
import { string } from "../../../../constants/string";

export default function VehicleSubmission({onHomeClick}:any) {

  return (
    <Box
      display="flex"
      flexDirection="column"
      alignItems="center"
      justifyContent="center"
      textAlign="center"
      px={2}
    >
      <Box>
        <img
          src={check}
          alt="Logo"
          style={{ height: 200, width: 200, objectFit: "contain" }}
        />
      </Box>

      <Typography fontSize={38} fontWeight={600} gutterBottom>
        {string.vehicle.heading}
      </Typography>

      <Typography fontSize={30} fontWeight={500} maxWidth={900} mb={4}>
        {string.vehicle.para}
      </Typography>

      <ButtonComp
        height={40}
        width={200}
        variant="contained"
        onClick={onHomeClick}
      >
        {string.vehicle.home}
      </ButtonComp>
    </Box>
    
  );
}
